import React, { Component } from 'react'
// import { Popover } from 'antd'
import compose from 'recompose/compose'
import { inject, observer } from 'mobx-react'
// import styled from 'styled-components'
import _get from 'lodash/get'
// import _first from 'lodash/first'
import _flatten from 'lodash/flatten'
import _find from 'lodash/find'
import _findLast from 'lodash/findLast'
import _groupBy from 'lodash/groupBy'
import _entries from 'lodash/entries'
import moment from 'moment'
import { Marker, InfoWindow } from 'react-google-maps'
import config from '~/config'
// import { Pin } from './styles'

const parameters = _get(config, 'app.parameters', [])
const SALINITY = parameters.find(p => p.name === 'ความเค็ม')
class SelectedStation extends Component {
  state = {
    infoOpen: true
  }
  render () {
    const { data, station, main, salinityRecords, view } = this.props // eslint-disable-line no-unused-vars
    // console.log({ salinity })
    const { mode, daysOffset } = view
    const today = moment(data.now).clone().set({ hour: 0, minute: 0, second: 0 })
    const responseData = data.responseData.get()
    let $responseData
    let color // eslint-disable-line no-unused-vars
    const currentDay = (mode === 'forecasting' || mode === 'scenario') ? today.clone().add(daysOffset, 'day') : today
    // const record = _find(dataSource, rec => currentDay.isSame(moment(rec.observedTimestamp), 'day'))
    if (responseData) {
      $responseData = Object.entries(responseData).map(([catId, records]) => (
        <div key={catId}>
          {_entries(_groupBy(_flatten(records[station.id]), 'type.name')).map(([typeName, records]) => {
            const record = _find(records, rec => currentDay.isSame(moment(rec.observedTimestamp), 'day'))
            return record && <div key={typeName}>
              <div>
                {typeName} : {record.value}
              </div>
            </div>
          })}
        </div>
      ))
    } else {
      $responseData = 'loading...'
    }
    const salinity = _findLast(salinityRecords, rec => currentDay.isSame(moment(rec.observedTimestamp), 'day'))
    if (salinity) {
      SALINITY.scales.forEach(([value, c]) => {
        if (salinity.value > value) {
          color = c
        }
      })
    }
    return <Marker
      icon={{
        path: main
        //          ? 'M22-48h-44v43h16l6 5 6-5h16z'
          ? 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z'
          : 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
        fillColor: color,
        fillOpacity: 1.0,
        strokeColor: 'black',
        strokeWeight: main ? 2 : 1
      }}
      // icon={main ? { url: '/public/main_marker.png', size: { width: 44, height: 80 } } : null }
      position={{ lat: station.latitude, lng: station.longitude }}
      label={station.stationName}
      onClick={() => this.setState({ infoOpen: true })}
    >
      {this.state.infoOpen && <InfoWindow onCloseClick={() => this.setState({ infoOpen: false })}>
        <div>
          <div>{station.stationName} ({currentDay.format('YYYY-MM-DD HH:mm')})</div>
          <div>{$responseData}</div>
        </div>
      </InfoWindow>}
    </Marker>
  }
}
export default compose(
  inject('data'),
  inject('view'),
  observer
)(SelectedStation)



// WEBPACK FOOTER //
// ./src/components/SelectedStation.js